import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { ProtectedRoute, AdminRoute } from "@/components/ProtectedRoute";
import { AppShell } from "@/components/AppShell";
import { InstallBanner } from "@/components/InstallBanner";

import Landing from "@/pages/Landing";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Courses from "@/pages/Courses";
import ExamDetail from "@/pages/ExamDetail";
import SubjectDetail from "@/pages/SubjectDetail";
import Tutor from "@/pages/Tutor";
import Quiz from "@/pages/Quiz";
import Simulateur from "@/pages/Simulateur";
import Revisions from "@/pages/Revisions";
import Leaderboard from "@/pages/Leaderboard";
import Pricing from "@/pages/Pricing";
import Admin from "@/pages/Admin";
import Archive from "@/pages/Archive";
import Filieres from "@/pages/Filieres";
import FiliereDetail from "@/pages/FiliereDetail";
import ParentSpace from "@/pages/ParentSpace";
import TeacherSpace from "@/pages/TeacherSpace";
import Documents from "@/pages/Documents";
import Sprint from "@/pages/Sprint";
import SchoolSpace from "@/pages/SchoolSpace";
import Diagnostic from "@/pages/Diagnostic";

const Shell = (el) => (
  <ProtectedRoute>
    <AppShell>{el}</AppShell>
  </ProtectedRoute>
);

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/a-propos" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/connexion" element={<Auth />} />
      <Route path="/bienvenue" element={<ProtectedRoute requireExam={false}><Onboarding /></ProtectedRoute>} />

      <Route path="/app" element={Shell(<Dashboard />)} />
      <Route path="/app/cours" element={Shell(<Courses />)} />
      <Route path="/app/cours/:examId" element={Shell(<ExamDetail />)} />
      <Route path="/app/cours/:examId/:subjectName" element={Shell(<SubjectDetail />)} />
      <Route path="/app/filieres" element={Shell(<Filieres />)} />
      <Route path="/app/filieres/:filiereId" element={Shell(<FiliereDetail />)} />
      <Route path="/app/parent" element={Shell(<ParentSpace />)} />
      <Route path="/app/enseignant" element={Shell(<TeacherSpace />)} />
      <Route path="/app/etablissement" element={Shell(<SchoolSpace />)} />
      <Route path="/app/tuteur" element={Shell(<Tutor />)} />
      <Route path="/app/sprint" element={Shell(<Sprint />)} />
      <Route path="/app/diagnostic" element={Shell(<Diagnostic />)} />
      <Route path="/app/quiz/:quizId" element={Shell(<Quiz />)} />
      <Route path="/app/simulateur" element={Shell(<Simulateur />)} />
      <Route path="/app/revisions" element={Shell(<Revisions />)} />
      <Route path="/app/examens" element={Shell(<Archive />)} />
      <Route path="/app/classement" element={Shell(<Leaderboard />)} />
      <Route path="/app/tarifs" element={Shell(<Pricing />)} />
      <Route path="/app/admin" element={<AdminRoute><AppShell><Admin /></AppShell></AdminRoute>} />
      <Route path="/app/admin/documents" element={<AdminRoute><AppShell><Documents /></AppShell></AdminRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-center" richColors />
        <AppRoutes />
        <InstallBanner />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
